import { __require as requireFunctionUncurryThis } from './node_modules-core-js-internals-function-uncurry-this.js';
import { __require as requireACallable } from './node_modules-core-js-internals-a-callable.js';

var functionUncurryThisAccessor;
var hasRequiredFunctionUncurryThisAccessor;

function requireFunctionUncurryThisAccessor () {
	if (hasRequiredFunctionUncurryThisAccessor) return functionUncurryThisAccessor;
	hasRequiredFunctionUncurryThisAccessor = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var aCallable = requireACallable();

	functionUncurryThisAccessor = function (object, key, method) {
	  try {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
	  } catch (error) { /* empty */ }
	};
	return functionUncurryThisAccessor;
}

export { requireFunctionUncurryThisAccessor as __require };
//# sourceMappingURL=node_modules-core-js-internals-function-uncurry-this-accessor.js.map
